const checkWindow = () => {
    if (!window || typeof window === 'undefined')
        return;
};
export const localStorage = () => ({
    get: (key) => {
        checkWindow();
        return window.localStorage.getItem(key);
    },
    set: (key, val) => {
        checkWindow();
        window.localStorage.setItem(key, val);
    },
    remove: (key) => {
        checkWindow();
        window.localStorage.removeItem(key);
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWwtc3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91dGlscy9sb2NhbC1zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sV0FBVyxHQUFHLEdBQUcsRUFBRTtJQUN2QixJQUFJLENBQUMsTUFBTSxJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVc7UUFBRSxPQUFNO0FBQ3RELENBQUMsQ0FBQTtBQVFELE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxHQUFpQixFQUFFLENBQUMsQ0FBQztJQUMvQyxHQUFHLEVBQUUsQ0FBQyxHQUFXLEVBQUUsRUFBRTtRQUNuQixXQUFXLEVBQUUsQ0FBQTtRQUNiLE9BQU8sTUFBTSxDQUFDLFlBQVksQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUE7SUFDekMsQ0FBQztJQUNELEdBQUcsRUFBRSxDQUFDLEdBQVcsRUFBRSxHQUFXLEVBQUUsRUFBRTtRQUNoQyxXQUFXLEVBQUUsQ0FBQTtRQUNiLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsRUFBRSxHQUFHLENBQUMsQ0FBQTtJQUN2QyxDQUFDO0lBQ0QsTUFBTSxFQUFFLENBQUMsR0FBVyxFQUFFLEVBQUU7UUFDdEIsV0FBVyxFQUFFLENBQUE7UUFDYixNQUFNLENBQUMsWUFBWSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNyQyxDQUFDO0NBQ0YsQ0FBQyxDQUFBIn0=